import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  constructor() { }

  public prepareRoute(...paths: string[]): string {
    let rootRoute = '/';
    return rootRoute.concat(paths.filter(Boolean).join('/'));
  }

  // private iframeVisible = new BehaviorSubject<boolean>(false);
  // iframeVisible$ = this.iframeVisible.asObservable();

  // setIframeVisible(value: boolean) {
  //   this.iframeVisible.next(value);
  // }

  // getIframeVisible(): boolean {
  //   return this.iframeVisible.getValue();
  // }

}
